import { Link } from 'react-router-dom';
import lemur from '@/styles/img/lemur.png';
import packageJson from '../../../package.json';
import css from './Footer.module.css';

const MENU = [
  { href: '/help', title: 'Помощь' },
  { href: '/terms', title: 'Правила' },
  { href: '/contacts', title: 'Контакты' },
  { href: '/about', title: 'О нас' }
];

const YEAR = new Date().getFullYear();
const version = packageJson.version ? `v${packageJson.version}` : '';

interface FooterProps {
  withLemur?: boolean;
  copyright?: boolean;
}

export function Footer({ withLemur, copyright = true }: FooterProps) {
  return (
    <footer data-testid="footer" style={{ position: 'absolute', bottom: '0', width: '100%', zIndex: 100 }}>
      <div className={[css.wrapper, withLemur ? css.withLemur : ''].filter(Boolean).join(' ')}>
        {withLemur && <img className={css.lemur} src={lemur} alt="lemur" />}
        <p className={css.copyright}>{`${copyright ? `2017 - ${YEAR} © ` : ''}Дыбр ${version}`}</p>
        <ul className={css.nav}>
          {MENU.map(item => (
            <li key={item.title} className={css.navItem}>
              <Link to={item.href}>{item.title}</Link>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
}
